var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-metric"},[_c('Icon',{attrs:{"icon":_vm.statusIcon,"color":_vm.met ? 'success' : 'error',"medium":false}}),_c('Typography',{attrs:{"variant":"subtitle-1","as":"span"}},[_vm._v(_vm._s(_vm.statusLabel))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }